<template>
    <!-- Add Review Modal -->
    <div class="modal custom-modal fade payment-modal" id="add-review" role="dialog">
        <div class="modal-dialog modal-dialog-centered modal-md">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="form-header modal-header-title">
                        <h4 class="mb-0">Write a Review</h4>
                    </div>
                    <a class="close" data-bs-dismiss="modal" aria-label="Close">
                        <span class="align-center" aria-hidden="true"><i class="feather-x"></i></span>
                    </a>
                </div>
                <div class="modal-body">
                    <form>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="input-space">
                                    <label class="form-label">Your Name <span>*</span></label>
                                    <input type="text" class="form-control" id="reviewer-name"
                                        placeholder="Enter Your Name">
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="input-space">
                                    <label class="form-label">Title of your review</label>
                                    <input type="text" class="form-control" id="title"
                                        placeholder="If you could say it in one sentence, what would you say?">
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="input-space">
                                    <label class="form-label">Your Review <span>*</span></label>
                                    <textarea class="form-control" id="review" rows="3"
                                        placeholder="Enter Your Review"></textarea>
                                    <small class="text-muted"><span id="chars">100</span> characters remaining</small>
                                </div>
                            </div>
                            <div class="col-lg-12">
                                <div class="input-space review">
                                    <label class="form-label">Rating <span>*</span></label>
                                    <div class="star-rating">
                                        <input id="star-5" type="radio" name="rating" value="star-5">
                                        <label for="star-5" title="5 stars">
                                            <i class="active fa fa-star"></i>
                                        </label>
                                        <input id="star-4" type="radio" name="rating" value="star-4">
                                        <label for="star-4" title="4 stars">
                                            <i class="active fa fa-star"></i>
                                        </label>
                                        <input id="star-3" type="radio" name="rating" value="star-3">
                                        <label for="star-3" title="3 stars">
                                            <i class="active fa fa-star"></i>
                                        </label>
                                        <input id="star-2" type="radio" name="rating" value="star-2">
                                        <label for="star-2" title="2 stars">
                                            <i class="active fa fa-star"></i>
                                        </label>
                                        <input id="star-1" type="radio" name="rating" value="star-1">
                                        <label for="star-1" title="1 star">
                                            <i class="active fa fa-star"></i>
                                        </label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-group">
                                <div class="terms-accept">
                                    <div class="d-flex align-items-center form-check">
                                        <input type="checkbox" id="terms_accept" class="form-check-input">
                                        <label for="terms_accept">I have read and accept <router-link
                                                to="/pages/terms-condition">Terms &amp; Conditions</router-link></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <div class="table-accept-btn">
                        <a href="javascript:;" class="btn btn-primary" data-bs-dismiss="modal" aria-label="Close">Add
                            Review</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- /Add Review Modal -->
</template>